export enum PlaceType {
  HISTORY = 'history',
  CITY = 'city',
  PROPERTY = 'property',
  PLACES = 'places',
  BOOKMARK = "bookmark"
} 

export enum PropertyStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active'
}
